import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FundList from './FundList';
import CreateFund from './CreateFund';
import FundDetails from './FundDetails';

/**
 * AI SUMMARY:
 * The Fund component serves as a router for the fund management section.
 * It defines routes for:
 * - Listing all funds (/fund/list)
 * - Creating a new fund (/fund/create)
 * - Viewing fund details (/fund/details/:fundId)
 *
 * The component uses React Router to handle navigation between these
 * different views while maintaining a consistent URL structure.
 */
const Fund = () => {
  return (
    <Routes>
      <Route path="list" element={<FundList />} />
      <Route path="create" element={<CreateFund />} />
      <Route path="details/:fundId" element={<FundDetails />} />
      <Route path="*" element={<FundList />} />
    </Routes>
  );
};

export default Fund;
